import { useId, useState } from "react";
import type { PracticeTaskMaterial } from "@wmf/shared/practiceReview";
import { GrooveSnapshotPlayer } from "./GrooveSnapshotPlayer.js";
import "./practiceTaskMaterials.css";
import { trackUsage } from "./analytics/usage.js";

export function PracticeTaskMaterials({ materials = [], practiceTarget }: { materials?: PracticeTaskMaterial[]; practiceTarget?:string }) {
  const [playing, setPlaying] = useState<string | null>(null);
  const playerId = useId();
  if (!materials.length) return null;
  return <div className="practice-task-materials" aria-label="Task materials">
    {materials.map(material => <div key={material.id}>
      {material.groove ? <>
        <button type="button" className="quiet small" aria-expanded={playing === material.id} onClick={() => {
          if (playing !== material.id) trackUsage("practice_resource_open");
          setPlaying(playing === material.id ? null : material.id);
        }}>
          {playing === material.id ? "Close" : "Open and play"} {material.title}
        </button>
        {playing === material.id && <GrooveSnapshotPlayer title={material.groove.title} query={material.groove.query} idPrefix={`${playerId}-${material.id}`} practiceTarget={practiceTarget} />}
      </> : material.href && <a className="small" href={material.href} target="_blank" rel="noopener noreferrer" onClick={() => trackUsage("practice_resource_open")}>Open {material.title}</a>}
    </div>)}
  </div>;
}
